import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import api from '@http/api';
import { useAuth } from '@hooks/AuthenticateContext';

import { Checkbox, Grid, IconButton, Card } from '@material-ui/core';
import { AddBox, ClearRounded, AddOutlined, Edit, VisibilityOff, TuneOutlined} from '@material-ui/icons';
import Button from '@components/Shared/Buttons/Button';
import { FormatDate } from '@utils/formats';
import { Form, Select as SelectAntd,  Input, Spin, Radio, Switch } from 'antd';
import {  addDays } from 'date-fns';

import Filtros from '@src/components/Shared/Filtros';
import TableCustomKeysNoPagination from '@src/components/Shared/Tables/TableCustomKeysNoPagination';
//import generatePDF from 'react-to-pdf';

import Services, {
  ILista,
  IGetAllProgramaTv,
} from './services';
import { fontSize } from '@mui/system';


const columnsLabel = {
  perfilId: 'Nome',
  programaId: 'Programa',
  descricao: 'Descrição',
  dataCadastro: 'Data cadastro'
};


let  dataSelect: any;
let  programaSelect: any;
let conteudo: any;

const SolicitacaoIntencaoMissa: React.FC = () => {
  const [formRef] = Form.useForm();
  const { user } = useAuth()
  const { enqueueSnackbar } = useSnackbar();

  const [data, setData] = useState<ILista[]>([]);
  const [statusSolicitacao, setStatusSolicitacao] = useState(true);

  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState(false);

  const [programas, setProgramas] = useState<IGetAllProgramaTv[]>([]);
  const [teste, setTeste] = useState<string>('');

  const [programaSelected, setProgramaSelected] = useState<number>(0);
  const [dataSelected, setDataSelected] = useState<string>('0001-01-01T00:00:00');
  const [horarioSelected, setHorarioSelect] = useState<any>('');


  conteudo = data.length <= 0



  const gerarCSV = async () => {
    setLoading(true);
    const services = new Services();
    const { error, response } = await services.GerarCSV(statusSolicitacao, programaSelected);

    if (!error && response) {
      window.open(response)
     }

    setLoading(false);
  };

  const gerarPDF = async () => {
    setLoading(true);
    const services = new Services();
    const { error, response } = await services.GerarPDF(statusSolicitacao, programaSelected);

    console.log("ajdskfjskdfejskdlfjksdl")
    if (!error && response) {
      window.open(response);
    }

    setLoading(false);

    console.log("sjdfhsdk789")
  };


  const testanod2 = async () => {

    if (loading === false){
      window.open(teste)
      console.log("JAJAJAJAJ",)
    }

    console.log("eeueueuue", loading)

  };

  async function loadListaAllPrograma() {
    setLoading(true);
    await api
      .get( `api/SolicitacaoPrograma/GetAllSolicitacaoPrograma?StatusSolicitacao=${statusSolicitacao}`)

      .then(response => {
        const items = response.data;
        const itemData: ILista[] = items.map((item: ILista) => ({
          id: item.id,
          perfilId: item.perfil.pessoa.nome,
          programaId: item.programa.nome,
          descricao: item.descricao,
          dataCadastro: FormatDate(item.dataCadastro),

        }));

        setData(itemData);
        setLoading(false);
      })
      .catch(error => {
        //alert(error);
        enqueueSnackbar(`Não foi possivel carregar a lista`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  }

  async function loadListaAllIntencaoMissaFiltros() {
    const programaSelecteds = formRef.getFieldValue('programa');
    setLoading(true);
    await api
      .get(`api/SolicitacaoPrograma/GetAllSolicitacaoPrograma?StatusSolicitacao=${statusSolicitacao}&ProgramaId=${programaSelected}`)

      .then(response => {
        const items = response.data;
        const itemData: ILista[] = items.map((item: ILista) => ({
          id: item.id,
          perfilId: item.perfil.pessoa.nome,
          programaId: item.programa.nome,
          descricao: item.descricao,
          dataCadastro: FormatDate(item.dataCadastro),
        }));

        setData(itemData);
        setLoading(false);
      })
      .catch(error => {
       //alert(error);
       enqueueSnackbar(`Não foi possivel carregar a lista`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      });
  }


  const loadProgramasTv = async () => {
    const services = new Services();
    const { error, response } = await services.GetAllProgramaTv();

    if (!error && response) {
      setProgramas(response);

    }
  };

  async function pegarData(data_agendada: Date){

    dataSelect = new Date (data_agendada).toISOString();
    setDataSelected(dataSelect)

  };

  async function pegarPrograma(programa: string){

    programaSelect = programa;
    console.log( 'prisdjflksjdflksjflksdjfks', programaSelect);
    console.log( 'socotto', programaSelect);
  };






  const handleOpen = () => {
    setFiltros(!filtros);
  };

  const clearData = () => {
    formRef.setFieldsValue({
      data_agendada: '',
      horario: '',
      programa: '',
    });
    setProgramaSelected(0)
    setDataSelected('0001-01-01T00:00:00')
    setHorarioSelect('')
  };


  useEffect(() => {
    loadListaAllPrograma();
    loadProgramasTv();
    //loadAllIntencoes();

    window.document.title = 'CRM - Lista Programa TV';
  }, []);


  return (
    <Grid container>
      <Grid
        container
        item
        sm={12}
        //justify="space-around"
        xs={12}
        lg={12}
        style={{ marginTop: 20 }}
      >
        <Grid item lg={12} sm={12} xs={12}>

          {/* Botões  */}
          <Grid container item lg={10} sm={10} xs={10} style={{ paddingTop: 10 }}>
            <Grid
              item
              md={6}
              lg={6}
              xs={6}
              style={{
                paddingRight: 5,
                paddingLeft: 5,
                alignSelf: 'flex-end',
                paddingTop: 10,
              }}
            >
              <Button
                color="secondary"
                fullWidth
                style={{
                  height: 46,
                  width: 200
                }}
                onClick={handleOpen}
              >
                <TuneOutlined style={{ marginRight: 10 }} /> Filtros
              </Button>
            </Grid>

            <Grid
              item
              md={3}
              lg={3}
              xs={4}
              style={{
                paddingRight: 5,
                paddingLeft: 20,
                alignSelf: 'end',
                paddingTop: 10,
              }}
            >
              <Button
                color="primary"
                style={{
                  height: 46,
                  width: 200
                }}
                onClick={gerarCSV}
                disabled={conteudo === true}
              >
                Gerar csv
              </Button>
            </Grid>
            <Grid
              item
              md={3}
              lg={3}
              xs={4}
              style={{
                paddingRight: 5,
                paddingLeft: 30,
                alignSelf: 'end',
                paddingTop: 10,
              }}
            >
              <Button
                color="primary"
                style={{
                  height: 46,
                  width: 200
                }}

                onClick={gerarPDF}
                disabled={conteudo === true}
              >
                Gerar PDF
              </Button>
            </Grid>
          </Grid>

          {/* Filtros  */}
          <Filtros abrir={filtros} openMenu={handleOpen}>
            <Grid
              item
              md={12}
              lg={12}
              xs={12}
              style={{ paddingRight: 10, paddingLeft: 10, paddingTop: 10 }}
            >
             <Form className="filtros " layout={'vertical'} form={formRef}
               initialValues={{
                data_agendada: '',
                horario: '',
                programa: '',
                }}
              >

                <Grid
                  item
                  md={12}
                  lg={12}
                  xs={12}
                  style={{
                    paddingRight: 10,
                    paddingLeft: 10,
                    alignSelf: 'flex-end',
                    paddingTop: 10,
                  }}
                >
                   <Form.Item
                    name="programa"
                    label={<label style={{ color: '#fff' }}>Programa</label>}
                  >
                   <SelectAntd
                      style={{ width: '100%' }}
                      onChange={(e: any) => {setProgramaSelected(e);}}
                    >
                      {programas.map((option, index) => (
                        <SelectAntd.Option key={option.id} value={option.id}>
                          {option.nome}
                        </SelectAntd.Option>
                      ))}
                    </SelectAntd>
                  </Form.Item>
                </Grid>




                <Grid
                  item container
                  md={12}
                  lg={12}
                  xs={12}
                  style={{
                    paddingRight: 5,
                    paddingLeft: 5,
                    //alignSelf: 'flex-end',
                    //paddingTop: 10,
                  }}
                >
                  <Grid
                  item
                  md={5}
                  lg={5}
                  xs={12}
                  style={{
                    paddingRight: 5,
                    paddingLeft: 5,
                    //alignSelf: 'flex-end',
                    paddingTop: 10,
                  }}
                >
                  <Button
                    color="primary"
                    fullWidth
                    style={{
                      height: 46,
                    }}
                    onClick={loadListaAllIntencaoMissaFiltros}
                    //onClick={() => {loadListaAllIntencaoMissaFiltros(); loadAllIntencoesFiltros()}}

                  >
                   Buscar
                  </Button>
                </Grid>

                <Grid
                  item
                  md={5}
                  lg={5}
                  xs={12}
                  style={{
                    paddingRight: 5,
                    paddingLeft: 5,
                    //alignSelf: 'flex-end',
                    paddingTop: 10,
                  }}
                >
                  <Button
                    color="default"
                    fullWidth
                    style={{
                      height: 46,
                    }}
                    onClick={(e: any) => {loadListaAllPrograma(); clearData(); }}
                  >
                    Limpar filtros
                  </Button>
                </Grid>
                </Grid>


              </Form>
            </Grid>
          </Filtros>

          {/* Tabela  */}

          <Grid container item lg={10} sm={10} xs={12} style={{ padding: 0 }}>
            <Grid
              item
              lg={12}
              xs={12}
              style={{ paddingRight: 2, paddingLeft: 2, paddingTop: 5 }}
            >

              <TableCustomKeysNoPagination
                loading={loading}
                columns={[columnsLabel]}
                FieldsBold={['programaId']}
                data={data}
                keys={[
                  'perfilId',
                  'programaId',
                  'descricao',
                  'dataCadastro',
                ]}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SolicitacaoIntencaoMissa;
